/**
 * AU-only comparison table group. GB international customers do not see this section.
 */
export const dataComplianceGroup = {
  id: 'dataCompliance',
  name: 'Data & Compliance',
  features: [
    {
      id: 'dataCompliance-dataStorageLocation',
      feature: {
        name: 'Data Storage Location',
        tooltipLabel: '',
      },
      parameters: [
        {
          id: '1',
          value: 'United States',
        },
        {
          id: '2',
          value: 'United States',
        },
        {
          id: '3',
          value: 'Australia',
        },
      ],
    },
    {
      id: 'dataCompliance-iso270012022',
      feature: {
        name: 'ISO27001:2022',
        tooltipLabel: '',
      },
      parameters: [
        {
          id: '1',
          value: false,
        },
        {
          id: '2',
          value: false,
        },
        {
          id: '3',
          value: true,
        },
      ],
    },
  ],
};
